module.exports = __webpack_public_path__ + "img/envelope-open.885e6782.svg";